// Recognises "the AI provider refused this input" failures so every surface
// (ImageAnimatorModal, the async job tray, AnimatorPanel, image generation)
// can show one localized explanation instead of the provider's raw English
// reason or a misleading "try again later". classifyAiProviderError is pure
// so the async widget, which has its own i18n shim, maps the kind to its own
// strings; studio surfaces use mapAiProviderErrorMessage.
//
// Sources (idea-middleware):
//  - gemini-animation-provider-v2: stable `GEMINI_SAFETY_BLOCKED:` /
//    `GEMINI_COPYRIGHT_BLOCKED:` prefixes followed by Google's reason.
//  - gemini-animation-provider (v1): "Gemini safety filters blocked ...".
//  - veo video-gen: "Request blocked by safety filters: ...".
//  - image-factory / flux / gpt-image: "Content policy violation: ..." or
//    `CONTENT_POLICY_ERROR: ...`.
//  - Azure/OpenAI avatar: "filtered due to ... content management policy".

import i18n from "i18next";

export const AI_BLOCK = { SAFETY: "safety", COPYRIGHT: "copyright" };

// Studio locale keys (locales/{en,es,tr}.js) for each block kind.
export const AI_BLOCK_I18N_KEY = {
  [AI_BLOCK.SAFETY]: "AiProviderSafetyBlocked",
  [AI_BLOCK.COPYRIGHT]: "AiProviderCopyrightBlocked",
};

const COPYRIGHT_RE =
  /celebrit|prominent person|famous person|copyright|trademark|ünlü kişi|ünlü referans|telif hak/i;

const SAFETY_RE =
  /content[ _]policy|content management policy|policy violation|safety filter|guardrail|blocked by policy|input blocked|content rejected|content filter|filtered due to|responsible ai|blocklist/i;

export function classifyAiProviderError(raw) {
  const msg = String(raw || "");
  if (!msg) return null;
  // Machine codes first: Google's reason text after the prefix can mention
  // either kind, the prefix is the backend's decision.
  if (msg.startsWith("GEMINI_COPYRIGHT_BLOCKED")) return AI_BLOCK.COPYRIGHT;
  if (msg.startsWith("GEMINI_SAFETY_BLOCKED")) return AI_BLOCK.SAFETY;
  if (COPYRIGHT_RE.test(msg)) return AI_BLOCK.COPYRIGHT;
  if (SAFETY_RE.test(msg)) return AI_BLOCK.SAFETY;
  return null;
}

// Localized studio message for a provider refusal, or null when `raw` is not
// one (callers keep their own fallback: raw text, generic message, ...).
export function mapAiProviderErrorMessage(raw) {
  const kind = classifyAiProviderError(raw);
  return kind ? i18n.t(AI_BLOCK_I18N_KEY[kind]) : null;
}
